<div class="all-pages">
<div class="container page" >
    <h2>Cupones de pago <button style="float: right;" class="btn btn-primary" (click)="downloadAsPDF()">Exportar a PDF</button></h2> 
    <div class="paySlip" #paySlip *ngFor="let page of pages">

      <div class="slip" *ngFor="let slip of page.slips">
        <div class="row">
            <div class="col-3 ">
                <div class="border">
                    PAGO#<br/>
                    {{ slip.installmentNo }}
                </div>
                
            </div>
            <div class="col-1">
                
            </div>
            <div class="col-2">
                <div class="border">
                    PAGO NUMERO<br/>
                    {{ slip.installmentNo }}
                </div>
            </div>
            <div class="col-2">
                <div class="border">
                    NUMERO CONTRATO<br/>
                    {{contractId}}
                </div>
                
            </div>
            <div class="col-2">
                <div class="border">
                    VENCIMIENTO<br/>
                    {{ slip.thisDate | date: 'shortDate' }}
                </div>
                
            </div>
            <div class="col-2">
                <div class="border">
                    PAGO<br/>
                    {{ slip.thisPaymentAmount | currency }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <div class="border">
                    VENCIMIENTO<br/>
                    {{ slip.thisDate | date: 'shortDate' }}
                </div>
                
            </div>
            <div class="col-1">
                
            </div>
            <div class="col-2">
                
            </div>
            <div class="col-2">
                
            </div>
            <div class="col-2">
                <div class="border">
                    FECHA ATRASO<br/>
                    {{ slip.expDate | date: 'shortDate' }}
                </div>
            </div>
            <div class="col-2">
                <div class="border">
                    INCLUYA RECARGO<br/>
                    {{ slip.recargo | currency }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <div class="border">
                    BALANCE DESPUES DE PAGO<br/>
                    {{ slip.thisEndingBalance | currency }}
                </div>
            </div>
            <div class="col-1">
                
            </div>
            <div class="col-2">
                
            </div>
            <div class="col-2">
                
            </div>
            <div class="col-2">
                
            </div>
            <div class="col-2">
                <div class="border">
                    CON RECARGO<br/>
                    {{slip.recargoPaymentAmount | currency}}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-3">
                <div class="border">
                    SU NUMERO DE CHEQUE<br/><br/>
                    ___________________
                </div>
            </div>
            <div class="col-1">
                
            </div>
            <div class="col-4">
                <div class="border">
                    <strong>{{solicitante.name}}</strong><br>
                    {{ solicitante.address.postalAddress1 }}, {{ solicitante.address.postalAddress2 }}<br>
                    {{ solicitante.address.postalCity }} {{ solicitante.address.postalState }} {{ solicitante.address.postalZip }}
                </div>
                
            </div>
            <div class="col-4" style="padding: 5px;">
                <strong>Central Credit Corp</strong><br>
                PO BOX 361958<br>
                San Juan PR 00936-1958
            </div>
        </div>
        <div class="row">
            <div class="col-2">

            </div>
            <div class="col-2">
                
            </div>
            <div class="col-8" style="padding: 10px 0px 10px 10px">
                ESCRIBA SU NUMERO DE CUENTA AQUÍ: _____________________________________
            </div>
        </div>
        <div class="row">
            <div class="col-md-12" style="font-size: 16px; text-align: center;">
                NO USE ESTE CUPON PARA PAGAR EN EL BANCO. SOLO PARA PAGAR EN NUESTRA OFICINA.
            </div>
        </div>
      </div>
    </div>
    
  </div>
      
</div>

<!-- <div class="container">
    <div id="pdfTable" #pdfTable>
      <h2>Angular HTML To PDF Generator Example - ItSolutionStuff.com</h2>
                
      <table class="table table-bordered slip2">
        <tbody>
          <tr>
            <td>
                   <div class="border"> PAGO#<br/></div>
            </td>
            <td>

            </td>
            <td>
                PAGO NUMERO<br/>
            </td>
            <td>
                NUMERO CONTRATO<br/>
            </td>
            <td>
                VENCIMIENTO<br/>
            </td>
            <td>
                PAGO<br/>
            </td>
          </tr>
          <tr>
            <td>
              VENCIMIENTO<br/>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              FECHA ATRASO<br/>
            </td>
            <td>
              INCLUYA RECARGO<br/>
            </td>
          </tr>
          <tr>
            <td>
              BALANCE DESPUES DE PAGO<br/>
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td>
              CON RECARGO<br/>
            </td>
          </tr>
          <tr>
            <td>
              SU NUMERO DE CHEQUE<br/><br/>
                    ___________________
            </td>
            <td></td>
            <td colspan="2">
              Address<br>
              Address<br>
              Address
            </td>
            <td colspan="2">
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="noBorder"></td>
            <td colspan="4" class="noBorder"> ESCRIBA SU NUMERO DE CUENTA AQUÍ: _____________________________________ </td>
          </tr>
          <tr>
            <td colspan="6" style="text-align: center;">
              NO USE ESTE CUPON PARA PAGAR EN EL BANCO. SOLO PARA PAGAR EN NUESTRA OFICINA.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <button class="btn btn-primary" (click)="downloadAsPDF()">Export To PDF</button>
  </div> -->